import { getCore } from "../../../api/services/axiosCore.service";

/**
 * Fetches the list of holidays from the core API.
 * @returns {Promise<Array>} A promise that resolves to an array of holiday objects.
 */
export const getHolidays = () => {
  return getCore("/holidays").then((res) => res.results);
};
